import React from 'react';
const SvgIndeterminate = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 32 32", focusable: false }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.9 14H27v4H4.9z" })));
export default SvgIndeterminate;
//# sourceMappingURL=Indeterminate.js.map